import { cva } from 'class-variance-authority';

const scdPickerBaseStyles = [
  'absolute',
  'max-h-48',
  'left-0',
  'border',
  'border-t-0',
  'shadow-md',
  'z-50',
  'w-full',
  'overflow-y-auto',
];

const scdPickerStylesSAG = cva([
  ...scdPickerBaseStyles,
  'bg-[#D1FFF2]',
  'border-[#005159]',

  'dark:bg-[#001F39]',
  'dark:border-[#00FFB9]',
]);

const scdPickerStylesSHS = cva([
  ...scdPickerBaseStyles,
  'bg-white',
  'border-0',
  'dark:bg-[#333333]',
]);

const textStylesPrimarySAG = cva(['dark:text-white', 'text-[#002828]']);

const textStylesPrimarySHS = cva(['dark:text-white', 'text-black']);

const textStylesSecondarySAG = cva(['dark:text-[#CCCCD4]', 'text-[#002828]']);

const textStylesSecondarySHS = cva(['dark:text-[#CCCCD4]', 'text-black']);

const searchResultStylesSAG = cva([
  'bg-[#E8E8E3]',
  'dark:bg-[#37374D]',
]);

const searchResultStylesSHS = cva([
  'bg-[#fafafa]',
  'dark:bg-[#37374D]',
]);


export {
  scdPickerStylesSAG,
  scdPickerStylesSHS,
  textStylesPrimarySAG,
  textStylesPrimarySHS,
  textStylesSecondarySAG,
  textStylesSecondarySHS,
  searchResultStylesSAG,
  searchResultStylesSHS,
};
